import { render } from "./ResultsDisplay.vue?vue&type=template&id=f3596256"
import script from "./ResultsDisplay.vue?vue&type=script&lang=js"
export * from "./ResultsDisplay.vue?vue&type=script&lang=js"

import "./ResultsDisplay.vue?vue&type=style&index=0&id=f3596256&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__